import HIKExchangePlatformModal from './HIK_exchange_platform-modal.vue'
export default HIKExchangePlatformModal
